interface FeatureContentWrapperProps {
  children: React.ReactNode;
}

export default function FeatureContentWrapper({
  children,
}: FeatureContentWrapperProps) {
  return <div className="flex flex-col flex-auto h-full">{children}</div>;
}
